import { fCommasAndDecimals } from 'utils/formatNumber'
import { MoneyAmount, MoneyAmountCurrencyCodeEnum } from '@types'

const NANO_CONVERTER = 1000000000

export const convertAmountStringToObject = (amountSet: string): MoneyAmount => {
  const [units, nanos] = amountSet.toString().split('.')
  return {
    units: parseInt(units.replaceAll(',', '')),
    nanos: parseInt(`${nanos || '00'}0000000`),
    currencyCode: MoneyAmountCurrencyCodeEnum.AUD
  }
}

export const getAmountValue = (amount: MoneyAmount) => {
  const nanoValueToDecimal = amount?.nanos ? amount?.nanos / NANO_CONVERTER : 0
  return (amount?.units ? amount?.units : 0) + nanoValueToDecimal
}

export const displayUserReadableAmount = (amount: MoneyAmount) => {
  return fCommasAndDecimals(getAmountValue(amount))
}

export const defineAmountState = (amount: MoneyAmount): string =>
  (amount?.units ?? 0) > 0 ? displayUserReadableAmount(amount) : ''

export const convertAmountStringToValue = (amount: string): number =>
  parseFloat(amount.replaceAll(',', ''))


  export const formatBusinessId = (cleaned) => {
    if (!cleaned) return '';
    if (cleaned.length === 11) {
      // ABN: 11 222 333 444
      return `${cleaned.slice(0,2)} ${cleaned.slice(2,5)} ${cleaned.slice(5,8)} ${cleaned.slice(8,11)}`;
    }
    if (cleaned.length === 9) {
      // ACN: 123 456 789
      return `${cleaned.slice(0,3)} ${cleaned.slice(3,6)} ${cleaned.slice(6,9)}`;
    }
    return cleaned; // fallback
    };